import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThirdPartySharedModule } from '../shared/module/third-party-shared.module';
import { AtlasSharedModule } from '../shared/module/atlas-shared.module';
import { AdjustUnappliedPaymentDialogComponent } from './transactions-grid/adjust-unapplied-payment-dialog/adjust-unapplied-payment-dialog.component';
import { CreditCardActivityComponent } from './credit-card-activity/credit-card-activity.component';
import { RevenueRoutingModule } from './revenue-routing.module';
import { CreditCardActivityDetailsDialogComponent } from './credit-card-activity/credit-card-activity-details-dialog/credit-card-activity-details-dialog.component';
import { InvoiceLineItemDetailsDialogComponent } from './invoice-line-item-details-dialog/invoice-line-item-details-dialog.component';
import { InvoiceLineItemDetailsComponent } from './invoice-line-item-details-dialog/invoice-line-item-details/invoice-line-item-details.component';
import { EcomTransactionsComponent } from './ecommerce/ecommerce-transactions/ecommerce-transactions.component';
import { PostedBatchesComponent } from './posted-batches/posted-batches.component';
import { DetailedTransactionsGridComponent } from './posted-batches/detailed-transactions-grid/detailed-transactions-grid.component';
import { JournalEntriesGridComponent } from './posted-batches/journal-entries-grid/journal-entries-grid.component';
import { PostTransactionsComponent } from './post-transactions/post-transactions.component';
import { PostTransactionsRequestSearchComponent } from './post-transactions/post-transactions-request-search/post-transactions-request-search.component';
import { JournalEntryDetailsComponent } from './journal-entry-details/journal-entry-details.component';
import { PostTransactionsSummaryComponent } from './post-transactions/post-transactions-summary/post-transactions-summary.component';
import { InvoiceFinderWriteOffComponent } from './invoice-finder/invoice-finder-write-off/invoice-finder-write-off.component';
import { ArbcreationComponent } from './arbcreation/arbcreation.component';
import { PledgeCampaignsComponent } from './pledge-campaigns/pledge-campaigns.component';
import { PledgeCampaignsAddDialogComponent } from './pledge-campaigns/pledge-campaigns-add-dialog/pledge-campaigns-add-dialog.component';
import { PledgeCampaignEditComponent } from './pledge-campaigns/pledge-campaign-edit/pledge-campaign-edit.component';
import { PledgeCampaignDetailsEditComponent } from './pledge-campaigns/pledge-campaign-edit/pledge-campaign-details-edit/pledge-campaign-details-edit.component';
import { PledgeCampaignPledgesComponent } from './pledge-campaigns/pledge-campaign-edit/pledge-campaign-pledges/pledge-campaign-pledges.component';
import { PledgeEditComponent } from './pledge/pledge-edit/pledge-edit.component';
import { PledgeEditDetailsComponent } from './pledge/pledge-edit/pledge-edit-details/pledge-edit-details.component';
import { PledgeAddDialogComponent } from './pledge/pledge-add-dialog/pledge-add-dialog.component';
import { PledgeEditBillingComponent } from './pledge/pledge-edit/pledge-edit-billing/pledge-edit-billing.component';
import { PledgeEditBillingListComponent } from './pledge/pledge-edit/pledge-edit-billing/pledge-edit-billing-list.component';
import { PledgeEditInvoicesComponent } from './pledge/pledge-edit/pledge-edit-invoices/pledge-edit-invoices.component';
import { PledgeCampaignDetailsEditProgressbarComponent } from './pledge-campaigns/pledge-campaign-edit/pledge-campaign-details-edit/pledge-campaign-details-edit-progressbar/pledge-campaign-details-edit-progressbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { GatewayResolutionTreeComponent } from './shared/gateway-resolution-tree/gateway-resolution-tree.component';
import { GatewayResolutionPageComponent } from './gateway-resolution-page/gateway-resolution-page.component';
import { GatewayResolutionSelectorComponent } from './gateway-resolution-selector/gateway-resolution-selector.component';
import { GatewayResolutionGraphComponent } from './gateway-resolution-graph/gateway-resolution-graph.component';

@NgModule({
  declarations: [
    AdjustUnappliedPaymentDialogComponent,
    CreditCardActivityComponent,
    CreditCardActivityDetailsDialogComponent,
    InvoiceLineItemDetailsDialogComponent,
    InvoiceLineItemDetailsComponent,
    EcomTransactionsComponent,
    PostedBatchesComponent,
    DetailedTransactionsGridComponent,
    JournalEntriesGridComponent,
    PostTransactionsComponent,
    PostTransactionsRequestSearchComponent,
    JournalEntryDetailsComponent,
    PostTransactionsSummaryComponent,
    ArbcreationComponent,
    PledgeCampaignsComponent,
    PledgeCampaignsAddDialogComponent,
    PledgeCampaignEditComponent,
    PledgeCampaignDetailsEditComponent,
    PledgeCampaignPledgesComponent,
    PledgeEditComponent,
    PledgeEditDetailsComponent,
    PledgeAddDialogComponent,
    PledgeEditBillingComponent,
    PledgeEditBillingListComponent,
    PledgeEditInvoicesComponent,
    PledgeCampaignDetailsEditProgressbarComponent,
    GatewayResolutionTreeComponent,
    GatewayResolutionPageComponent,
    GatewayResolutionSelectorComponent,
    GatewayResolutionGraphComponent,
  ],
  imports: [RevenueRoutingModule, CommonModule, AtlasSharedModule, ThirdPartySharedModule, TranslateModule],
  exports: [AdjustUnappliedPaymentDialogComponent, InvoiceLineItemDetailsDialogComponent],
})
export class RevenueModule {}
